// Conditional line-item property capture for event ticket products.
// Shows/hides buyer field groups based on the selected ticket package and
// enables/disables their inputs so only the relevant package's fields submit.
(function () {
  function initRoot(root) {
    if (root.dataset.ticketInit === 'true') return;
    root.dataset.ticketInit = 'true';

    const configEl = root.querySelector('script[data-ticket-config]');
    if (!configEl) return;

    let cfg;
    try {
      cfg = JSON.parse(configEl.textContent);
    } catch (e) {
      return;
    }

    const productId = String(cfg.productId);
    const groups = cfg.groups || {};
    const variants = cfg.variants || {};

    function optionsFor(variantId) {
      if (variantId == null) return [];
      return variants[String(variantId)] || [];
    }

    function apply(variantId) {
      const options = optionsFor(variantId).map((o) => String(o));

      root.querySelectorAll('[data-group-key]').forEach((group) => {
        const packages = groups[group.dataset.groupKey] || [];
        const active = options.some((o) => packages.indexOf(o) !== -1);
        group.hidden = !active;
        group.querySelectorAll('input, select, textarea').forEach((el) => {
          el.disabled = !active;
          if (el.dataset.required === 'true') el.required = active;
        });
      });

      root.querySelectorAll('[data-perks-variant]').forEach((el) => {
        el.hidden = String(el.dataset.perksVariant) !== String(variantId);
      });
    }

    apply(cfg.selectedVariantId);

    document.addEventListener('variant:update', (event) => {
      const detail = event.detail || {};
      const data = detail.data || {};
      if (String(data.productId) !== productId) return;
      const resource = detail.resource;
      apply(resource ? resource.id : null);
    });
  }

  function init() {
    document.querySelectorAll('[data-ticket-root]').forEach(initRoot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
